module.exports = __webpack_public_path__ + "img/leveler-3-off.8cb7e32c.png";